import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import moment from 'moment'

import docLoader from '../../docLoader.js'

import './Doc.css';

class Doc extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);
  }

  render(){
    const { dispatch, patternManager } = this.props; 
    const state = this.state;

    const d = this.props.doc;

    return <Link to={"/docs/d/" + d.slug}>
      <div className="col-themed col-themed-small-shadow col-themed-half-pad col-themed-hover-shadow col-themed-light-blue">
        <div className="text-heavy text-primary">{d.title}</div>
        <span className="doc-category-label">{d.category.name}</span>
      </div>
    </Link>
  }
}
const mapStateToProps = (state) => {
  const { patternManager } = state;

  return {
    patternManager
  }
}

export default connect(mapStateToProps)(Doc);



// WEBPACK FOOTER //
// ./src/components/Doc/DocThumbnail.js